export const options = (
    lineArray,
    lineArrayWithMarkers,
    precAcuArray,
    maxValuePrecAcuY,
    precAcuBackground,
    maxValueY,
    minValueY,
    hasPrecAcu,
    dataLabelLine = `°`
) => {
    const translateYLabelsPrecAcu = -17;
    const colors = {
        textLabelsPrecAcu: '#8f97a2',
        barsPrecAcu: 'rgba(95, 186, 227, .3)',
        backgroundPrecAcu: '#f8f9fa',
        white: '#fff',
        lineStroke: '#5fbae3',
    };
    const xAxis = {
        minValueAdjustment: 0.1,
        maxValueAdjustment: -1.1,
    };
    const yAxisOffset = -40;

    const precAcuBgSerie = {
        name: 'PrecAcuBackground',
        type: 'column',
        data: precAcuBackground,
        stack: 0,
        dataLabels: {
            enabled: false,
        },
    };

    const precAcuSerie = {
        name: 'PrecAcu',
        type: 'column',
        data: precAcuArray,
        stack: 0,
        dataLabels: {
            inside: true,
            verticalAlign: 'bottom',
            y: translateYLabelsPrecAcu,
            style: {
                color: `${colors.textLabelsPrecAcu}!important`,
            },
        },
    };

    const iconsSerie = {
        name: 'EstCel',
        type: 'line',
        stacking: null,
        stack: 1,
        data: lineArrayWithMarkers,
        yAxis: 1,
    };

    const colorPrecAcu =
        hasPrecAcu === true ? colors.barsPrecAcu : colors.backgroundPrecAcu;

    const valuesSerie = {
        name: 'Temp',
        type: 'line',
        stacking: null,
        data: lineArray,
        yAxis: 1,
        marker: {
            symbol: 'circle',
        },
    };

    const series = [precAcuBgSerie, precAcuSerie, iconsSerie, valuesSerie];

    return {
        chart: {
            margin: 0,
            spacing: 0,
            backgroundColor: colors.white,
        },
        title: {
            text: null,
        },
        credits: {
            enabled: false,
        },
        xAxis: {
            tickColor: colors.white,
            labels: {
                enabled: false,
            },
            lineColor: colors.white,
            min: 0 + xAxis.minValueAdjustment,
            max: 24 + xAxis.maxValueAdjustment,
        },
        yAxis: [
            {
                // Primary yAxis
                title: {
                    text: null,
                },
                labels: {
                    enabled: false,
                },
                max: maxValuePrecAcuY,
                min: 0,
                gridLineColor: colors.white,
                offset: yAxisOffset,
            },
            {
                // Secondary yAxis
                title: {
                    text: null,
                },
                labels: {
                    enabled: false,
                },
                gridLineColor: colors.white,
                tickPositions: [minValueY, maxValueY],
            },
        ],
        tooltip: {
            enabled: false,
        },
        legend: {
            enabled: false,
        },
        // X, y, z, line
        colors: [
            colors.backgroundPrecAcu,
            colorPrecAcu,
            colors.lineStroke,
            colors.lineStroke,
        ],
        plotOptions: {
            series: {
                allowPointSelect: true,
                lineWidth: 1,
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '9px',
                        fontWeight: 'normal',
                        textOutline: '0',
                    },
                },
                stacking: 'normal',
                gapSize: 0,
            },
            line: {
                dataLabels: {
                    format: `{point.y:,.0f}${dataLabelLine}`,
                },
                marker: {
                    radius: 2,
                },
                enableMouseTracking: false,
            },
            column: {
                align: 'center',
                allowOverlap: true,
                pointWidth: 17,
                borderWidth: 0,
                pointPadding: 0,
            },
        },
        series: series,
    };
};



// WEBPACK FOOTER //
// ./src/partials/DataViz/Charts/options.js